import type { AssignmentMap } from "../SettingsPayload";

import { parseTargetRef } from "./targetRef";

/**
 * どの生成担当にも名指されていない要素の creationId を返す。
 *
 * 枚そのものを名指している担当（`slide:` 参照）が 1 つでもあれば、その枚の要素はすべて
 * 覆われているとみなす。枚を名指すことは、そこに載っている枠を任せることを意味するため。
 */
export function selectUncoveredElements(
    assignments: AssignmentMap,
    slideId: string,
    creationIds: readonly string[]
): string[] {
    const covered = new Set<string>();
    for (const assignment of Object.values(assignments)) {
        for (const ref of assignment.targets) {
            const parsed = parseTargetRef(ref);
            if (parsed.kind === "slide") {
                if (parsed.officeId === slideId) return [];
                continue;
            }
            covered.add(parsed.officeId);
        }
    }
    return creationIds.filter((id) => !covered.has(id));
}
